import { MutableRefObject, useRef } from 'react';

export default function useDeepRef<Type = any>(value: any): MutableRefObject<Type> {
  const ref = useRef(value);
  ref.current = value;

  return ref;
}
